/**
 * Browser preference for the pale amber "positions mode" shell tint.
 * Defaults to on; only an explicit `false` turns the highlight off.
 */

import {
  addLocalStorageItem,
  getLocalStorageItem,
  removeLocalStorageItem,
} from "src/services/localStorage";
import { EventBus, EVENTS } from "src/services/eventEmitter";

const STORAGE_KEY = "teamform.positionsHighlight";

type Listener = () => void;

type StorageChangedPayload = {
  key?: string;
};

export const isPositionsHighlightEnabled = (): boolean =>
  getLocalStorageItem(STORAGE_KEY) !== false;

export const setPositionsHighlightEnabled = (enabled: boolean): void => {
  if (enabled) {
    // Default is on — clear so other tabs / fresh sessions stay default-on.
    removeLocalStorageItem(STORAGE_KEY);
  } else {
    addLocalStorageItem(STORAGE_KEY, false);
  }
  EventBus.emit(EVENTS.STORAGE_CHANGED, {
    key: STORAGE_KEY,
    value: enabled,
  });
};

export const subscribePositionsHighlight = (
  listener: Listener
): (() => void) => {
  const handler = (payload?: StorageChangedPayload) => {
    if (payload?.key === STORAGE_KEY) {
      listener();
    }
  };
  EventBus.on(EVENTS.STORAGE_CHANGED, handler);
  return () => {
    EventBus.off(EVENTS.STORAGE_CHANGED, handler);
  };
};
